import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import Api from '@/services/http'
import { taskUrl } from '@/services/url'
import type { AppDispatch } from '@/store'
import * as Types from './type'

const initialState: Types.TaskType = {
  taskInfo: {
    pageNum: 1,
    list: [],
    hasNext: false,
    socketData: [],
  },
  unReadTaskCount: 0,
  isOpen: false,
}

/**
 * 任务中心
 */

const TaskSlice = createSlice({
  name: 'task',
  initialState: initialState,
  reducers: {
    setTaskList(state, action: PayloadAction<Types.ITaskListResponse>) {
      const { pageNum, list, hasNext } = action.payload
      return {
        ...state,
        taskInfo: {
          ...state.taskInfo,
          pageNum,
          hasNext,
          list: pageNum >= 2 ? state.taskInfo.list.concat(list) : list,
        },
      }
    },
    setSocketTaskList(state, action: PayloadAction<Types.ITaskInfo[]>) {
      const data = action.payload
      const list = data.length ? state.taskInfo.socketData.concat(data) : data
      return {
        ...state,
        taskInfo: {
          ...state.taskInfo,
          socketData: list,
        },
      }
    },
    setUnReadTaskCount(state, action: PayloadAction<{ taskCount: number }>) {
      return {
        ...state,
        unReadTaskCount: action.payload.taskCount,
      }
    },

    /** 打开任务中心 */
    openCtr(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        isOpen: action.payload,
      }
    },
  },
})

export const { setTaskList, setUnReadTaskCount, openCtr } = TaskSlice.actions

/** 任务中心信息 */
export const queryTaskList =
  (props: { pageNum?: number; pageSize?: number } = {}) =>
  async (dispatch: AppDispatch) => {
    const { pageNum = 1, pageSize = 10 } = props
    const response = await Api.admin.get<Types.ITaskListResponse>(taskUrl.getTaskList, { params: { pageNum, pageSize } })
    const { data: rstData, code } = response
    if (code === 'SUCCESS') {
      const { pageNum, list } = rstData
      /** 已读处理 */
      const batchTaskIds = list.filter((task) => !task.read && ![Types.StatusEnum.PENDING, Types.StatusEnum.PROCESSING].includes(task.taskStatus)).map((task) => task.batchTaskId)
      dispatch(setTaskList({ pageNum, list, hasNext: list.length !== pageSize }))
      if (batchTaskIds.length) {
        const response = await Api.admin.post(taskUrl.setTaskHasBeenRead, { batchTaskIds })

        const { data, code } = response
        if (code === 'SUCCESS') {
          dispatch(setUnReadTaskCount({ taskCount: data.unReadCount }))
        }
      }
    }
  }

/** 获取任务中心未读数 */
export const getCountOfUnread = () => async (dispatch: AppDispatch) => {
  const response = await Api.admin.get<Types.ICountOfUnreadResponse>(taskUrl.getCountOfUnread)
  const { data, code } = response
  if (code === 'SUCCESS') {
    dispatch(setUnReadTaskCount({ taskCount: data.unReadCount }))
  }
}

export default TaskSlice.reducer
